import './InlineAlert.css';
export default {
    "root": "InlineAlert_root__1lv7r",
    "icon": "InlineAlert_icon__1lv7r",
    "info": "InlineAlert_info__1lv7r",
    "danger": "InlineAlert_danger__1lv7r",
    "success": "InlineAlert_success__1lv7r",
    "warning": "InlineAlert_warning__1lv7r",
    "opportunity": "InlineAlert_opportunity__1lv7r",
    "mainCol": "InlineAlert_mainCol__1lv7r",
    "body": "InlineAlert_body__1lv7r",
    "title": "InlineAlert_title__1lv7r",
    "description": "InlineAlert_description__1lv7r",
    "iconCol": "InlineAlert_iconCol__1lv7r",
    "cta": "InlineAlert_cta__1lv7r",
    "close": "InlineAlert_close__1lv7r",
    "closeButton": "InlineAlert_closeButton__1lv7r",
    "bodyHasCloseButton": "InlineAlert_bodyHasCloseButton__1lv7r"
};
